import React from 'react';
import Breadcrumbs from '@hpstellar/core/Breadcrumbs';

import { Helpers } from '../../core/src/helpers';
import JsonLd from '../../shared/components/json-ld';
import useDeviceInfo from '../../hooks/useDeviceInfo';

const getJsonLdBreadcrumbData = breadcrumbs => {
    const itemListElement = breadcrumbs.reduce((jsonLdArray, breadcrumbItem, i) => {
        let { label: name, href } = breadcrumbItem || {};
        const breadcrumbLink = href;
        if (!breadcrumbLink || breadcrumbLink.length === 0) {
            return jsonLdArray;
        }
        let itemHref = breadcrumbLink[0] === '/' ? Helpers.getAbsoluteRedirectPath(breadcrumbLink) : breadcrumbLink;
        jsonLdArray.push({
            '@type': 'ListItem',
            position: i + 1,
            name,
            item: itemHref,
        });

        return jsonLdArray;
    }, []);

    return itemListElement && itemListElement.length > 0
        ? {
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement,
          }
        : null;
};

const JsonLdBreadcrumbs = ({ breadcrumbs }) => {
    let parsedBreadcrumbs = breadcrumbs.slice();
    const jsonLdData = getJsonLdBreadcrumbData(parsedBreadcrumbs);
    return jsonLdData ? <JsonLd type="breadcrumb" data={jsonLdData} /> : null;
};

/***
 * GUX Breacrumbs component with JSONLD for SEO
 */
export default ({ breadcrumbs, disableMobileBreadcrumb, ...rest }) => {
    const { device } = useDeviceInfo(['device']);
    const gtmActions = new Map([
        [
            'linkClick',
            {
                gtmId: 'breadcrumb',
                gtmCategory: 'linkClick',
            },
        ],
    ]);
    if (device === 'mobile' && disableMobileBreadcrumb) {
        return null;
    }
    return (
        <>
            <Breadcrumbs gtmActions={gtmActions} breadcrumbs={breadcrumbs} {...rest} />
            {breadcrumbs && breadcrumbs.length > 0 && <JsonLdBreadcrumbs breadcrumbs={breadcrumbs} />}
        </>
    );
};
